export const TOKEN = 'token';

export const USER = 'user';

export const NOW = 'now';
